define('taoQtiItem/qtiXmlRenderer/renderers/interactions/ExtendedTextInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/blockInteraction'], function(tpl){
    return {
        qtiClass : 'extendedTextInteraction',
        template : tpl
    };
});
